import { ProcessingCommand, CommandType } from '../types/media';

export function processCommand(command: string): ProcessingCommand {
  const lowerCommand = command.toLowerCase().trim();
  const id = Date.now().toString();
  
  // Video editing commands
  if (lowerCommand.includes('cut') || lowerCommand.includes('trim')) {
    const timeMatch = lowerCommand.match(/(\d+)\s*(second|minute|min)s?/);
    const startTime = timeMatch ? parseInt(timeMatch[1]) : 0;
    
    return {
      id,
      command,
      type: 'cut' as CommandType,
      parameters: { startTime, endTime: startTime + 10 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('merge') || lowerCommand.includes('combine')) {
    return {
      id,
      command,
      type: 'merge' as CommandType,
      parameters: { method: 'concatenate' },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('black and white') || lowerCommand.includes('grayscale')) {
    return {
      id,
      command,
      type: 'filter' as CommandType,
      parameters: { filter: 'grayscale', intensity: 1 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('vintage') || lowerCommand.includes('sepia')) {
    return {
      id,
      command,
      type: 'filter' as CommandType,
      parameters: { filter: 'vintage', intensity: 0.8 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('cinematic')) {
    return {
      id,
      command,
      type: 'filter' as CommandType,
      parameters: { filter: 'cinematic', contrast: 1.2, saturation: 0.9 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('warm')) {
    return {
      id,
      command,
      type: 'filter' as CommandType,
      parameters: { filter: 'temperature', warmth: 1.3 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('cool')) {
    return {
      id,
      command,
      type: 'filter' as CommandType,
      parameters: { filter: 'temperature', warmth: 0.7 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('fade') || lowerCommand.includes('transition')) {
    return {
      id,
      command,
      type: 'transition' as CommandType,
      parameters: { type: 'fade', duration: 1 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('text') || lowerCommand.includes('caption') || lowerCommand.includes('subtitle')) {
    const textMatch = lowerCommand.match(/"([^"]+)"/);
    const text = textMatch ? textMatch[1] : 'Sample Text';
    
    return {
      id,
      command,
      type: 'text' as CommandType,
      parameters: { text, position: 'bottom', fontSize: 24 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('slow') || lowerCommand.includes('speed')) {
    const speedMatch = lowerCommand.match(/(\d*\.?\d+)x/);
    const speed = speedMatch ? parseFloat(speedMatch[1]) : 0.5;
    
    return {
      id,
      command,
      type: 'speed' as CommandType,
      parameters: { speed },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('background') || lowerCommand.includes('replace background')) {
    return {
      id,
      command,
      type: 'background' as CommandType,
      parameters: { type: 'cityscape', blur: 5 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  // Audio editing commands
  if (lowerCommand.includes('pitch')) {
    const pitchMatch = lowerCommand.match(/pitch.*?(\d+)/);
    const pitch = pitchMatch ? parseInt(pitchMatch[1]) : 0;
    
    return {
      id,
      command,
      type: 'pitch' as CommandType,
      parameters: { pitch: pitch > 0 ? pitch : 2 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('tempo') || lowerCommand.includes('speed')) {
    const tempoMatch = lowerCommand.match(/(\d*\.?\d+)/);
    const tempo = tempoMatch ? parseFloat(tempoMatch[1]) : 1.2;
    
    return {
      id,
      command,
      type: 'tempo' as CommandType,
      parameters: { tempo },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('noise') || lowerCommand.includes('clean')) {
    return {
      id,
      command,
      type: 'noise_reduction' as CommandType,
      parameters: { intensity: 0.7 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('equalizer') || lowerCommand.includes('eq')) {
    return {
      id,
      command,
      type: 'equalizer' as CommandType,
      parameters: { bass: 1.2, mid: 1.0, treble: 1.1 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('reverb') || lowerCommand.includes('echo')) {
    return {
      id,
      command,
      type: 'reverb' as CommandType,
      parameters: { roomSize: 0.5, damping: 0.3 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('robotic') || lowerCommand.includes('robot')) {
    return {
      id,
      command,
      type: 'voice_conversion' as CommandType,
      parameters: { type: 'robotic', intensity: 0.8 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  if (lowerCommand.includes('female') || lowerCommand.includes('male')) {
    const gender = lowerCommand.includes('female') ? 'female' : 'male';
    return {
      id,
      command,
      type: 'voice_conversion' as CommandType,
      parameters: { type: gender, pitch: gender === 'female' ? 1.3 : 0.8 },
      timestamp: Date.now(),
      status: 'pending'
    };
  }
  
  // Default command
  return {
    id,
    command,
    type: 'filter' as CommandType,
    parameters: { filter: 'enhance', intensity: 0.5 },
    timestamp: Date.now(),
    status: 'pending'
  };
}